export function createSuperAPIFactory(
// NOTE: hostType is ignored in that case, however, it could be used to return a different SuperAPI per host
// @ts-expect-error
hostType, hostAPI, ds) {
    // NOTE: for old API we don't use context and take information from arguments
    // @ts-expect-error
    return (context) => {
        return {
            accessibility: {
                getSkipToContent: async () => ds.accessibility.skipToContent.get(),
                setSkipToContent: async (appDefinitionId, value) => {
                    ds.runInContext(appDefinitionId, () => ds.accessibility.skipToContent.set(value));
                    await ds.waitForChangesAppliedAsync();
                },
                getVisualFocus: async () => ds.accessibility.visualFocus.get(),
                setVisualFocus: async (appDefinitionId, value) => {
                    ds.runInContext(appDefinitionId, () => ds.accessibility.visualFocus.set(value));
                    await ds.waitForChangesAppliedAsync();
                },
                getAutoDomReorder: async () => ds.accessibility.autoDomReorder.get(),
                setAutoDomReorder: async (appDefinitionId, value) => {
                    ds.runInContext(appDefinitionId, () => ds.accessibility.autoDomReorder.set(value));
                    await ds.waitForChangesAppliedAsync();
                },
                getAdvancedSettings: () => {
                    return hostAPI.accessibility.getAdvancedSettings();
                },
                setAdvancedSettings: (value) => {
                    return hostAPI.accessibility.setAdvancedSettings(value);
                },
            },
        };
    };
}
//# sourceMappingURL=accessibility.super.js.map